var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3846 1H5.61538C3.06638 1 1 3.06638 1 5.61538V16.3846C1 18.9336 3.06638 21 5.61538 21H16.3846C18.9336 21 21 18.9336 21 16.3846V5.61538C21 3.06638 18.9336 1 16.3846 1Z",
    stroke: "#5EB85B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.38477 12.5384L9.53861 15.0614C9.62331 15.1312 9.72249 15.1812 9.82894 15.2078C9.93539 15.2344 10.0464 15.237 10.154 15.2153C10.2626 15.1949 10.3655 15.1514 10.4558 15.0877C10.546 15.024 10.6215 14.9416 10.6771 14.8461L15.6155 6.38452",
    stroke: "#5EB85B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.00187c41f6f395f84c66c7cd2470b3eb.svg";
export { ForwardRef as ReactComponent };